// Capability-based access — permissions control access, not the interface.
// Mirrors backend ROLE_CAPABILITIES in routes/catalog.py.
export const ROLE_CAPABILITIES = {
  SUPER_ADMIN: ['*'],
  ADMIN: ['menu.manage', 'pricing.edit', 'menu.availability', 'promotions.manage',
    'cms.manage', 'delivery.config', 'reports.view', 'payments.record', 'payments.config', 'refunds.process', 'cash.manage'],
  POS: ['menu.manage', 'pricing.edit', 'menu.availability', 'promotions.manage',
    'promotions.apply', 'cms.manage', 'orders.operate', 'payments.record', 'payments.config', 'refunds.process', 'cash.manage', 'delivery.config'],
};

export function hasCapability(user, capability) {
  if (!user) return false;
  const role = typeof user.role === 'string' ? user.role : user.role?.value;
  const caps = ROLE_CAPABILITIES[role] || [];
  const extra = user.permissions || [];
  return caps.includes('*') || caps.includes(capability) || extra.includes(capability);
}
